import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function DomainInsureIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.027 0.804688L20.5489 6.40092L18.6241 7.52957L12.0235 3.1951L5.03132 7.75791C5.18477 10.1563 5.59017 13.1489 6.61303 15.7058C7.69372 18.4073 9.37878 20.4372 12.021 20.981C13.8819 20.5788 15.3258 19.3317 16.4248 17.7307C17.56 16.077 18.2646 14.1302 18.6241 12.6385L20.5684 13.107C20.1707 14.7574 19.3864 16.9503 18.0737 18.8626C16.7594 20.7772 14.8531 22.4948 12.2068 22.9833L12.0287 23.0162L11.8504 22.9845C8.13536 22.3249 5.98557 19.522 4.7561 16.4486C3.5275 13.3774 3.12932 9.8428 3.00127 7.28684L2.97253 6.71321L12.027 0.804688Z",
    fill: "currentColor"
  }));
}